var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useReducer } from 'react';
import { useExperienceState } from 'shared/features/experience-state';
export var TourContextActions;
(function (TourContextActions) {
    TourContextActions[TourContextActions["ACTIVATE_FLAG"] = 0] = "ACTIVATE_FLAG";
    TourContextActions[TourContextActions["COMPLETE_FLAG"] = 1] = "COMPLETE_FLAG";
    TourContextActions[TourContextActions["SET_COMPLETED_FLAGS"] = 2] = "SET_COMPLETED_FLAGS";
})(TourContextActions || (TourContextActions = {}));
var initialState = {
    activeFlags: [],
    completedFlags: [],
};
var TourContext = React.createContext({
    state: initialState,
    dispatch: function () { return null; },
});
var TourProvider = function (_a) {
    var children = _a.children;
    var _b = useExperienceState(), experienceState = _b.data, isFetched = _b.isFetched;
    var _c = useReducer(function (state, action) {
        switch (action.type) {
            case TourContextActions.ACTIVATE_FLAG:
                if (state.activeFlags.includes(action.payload)) {
                    return state;
                }
                return __assign(__assign({}, state), { activeFlags: __spreadArray(__spreadArray([], state.activeFlags, true), [action.payload], false) });
            case TourContextActions.COMPLETE_FLAG:
                if (state.completedFlags.includes(action.payload)) {
                    return state;
                }
                return __assign(__assign({}, state), { completedFlags: __spreadArray(__spreadArray([], state.completedFlags, true), [action.payload], false) });
            case TourContextActions.SET_COMPLETED_FLAGS:
                return __assign(__assign({}, state), { completedFlags: __spreadArray(__spreadArray([], state.completedFlags, true), action.payload, true) });
            default:
                throw new Error('Invalid action');
        }
    }, initialState), state = _c[0], dispatch = _c[1];
    useEffect(function () {
        if (experienceState) {
            dispatch({
                type: TourContextActions.SET_COMPLETED_FLAGS,
                payload: experienceState.tour_flags,
            });
        }
    }, [isFetched]);
    return _jsx(TourContext.Provider, __assign({ value: { state: state, dispatch: dispatch } }, { children: children }));
};
var useTourContext = function () {
    var context = React.useContext(TourContext);
    var dispatch = context.dispatch;
    if (context === undefined) {
        throw new Error('useTourContext must be used within a TourProvider');
    }
    var activateTourFlag = function (payload) {
        dispatch({ type: TourContextActions.ACTIVATE_FLAG, payload: payload });
    };
    var completeTourFlag = function (payload) {
        dispatch({ type: TourContextActions.COMPLETE_FLAG, payload: payload });
    };
    return __assign(__assign(__assign({}, context), context.state), { activateTourFlag: activateTourFlag, completeTourFlag: completeTourFlag });
};
export { TourProvider, useTourContext };
